/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: Result.ts
 * Created by: Kevin
 * Create Date: 2022-12-12 16:30
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {StatusDef} from "@/commons/StatusDef";
import {HttpStatus} from "@/commons/https/HttpStatus";

export default class Result<A> {

    private readonly _status: StatusDef | HttpStatus;
    private readonly _data: A | null;
    private readonly _response: any;
    private readonly _error: any;

    public constructor(status: StatusDef | HttpStatus, data: A | null, rsp?: any, err?: any) {
        this._status = status;
        this._data = data;
        this._response = rsp;
        this._error = err;
    }

    public static of<A>(status: StatusDef | HttpStatus, data?: A | null | undefined, rsp?: any, err?: any): Result<A> {
        let d: A | null;
        if (data === undefined) {
            d = null;
        } else {
            d = data;
        }
        return new Result<A>(status, d, rsp, err);
    }


    public isPresent(): boolean {
        return this._data != null;
    }

    public isSuccess(): boolean {
        return this._status == StatusDef.Success;
    }

    public isPermissionDenied(): boolean {
        return this._status == StatusDef.ErrPermissionDenied;
    }

    public isInUsing(): boolean {
        return this._status == StatusDef.ErrInUsing;
    }

    public isAlreadyExists(): boolean {
        return this._status == StatusDef.ErrAlreadyExists;
    }

    public isEmptyData(): boolean {
        return this._status == StatusDef.ErrEmptyData;
    }

    get status(): StatusDef | HttpStatus {
        return this._status;
    }

    get data(): A | null {
        return this._data;
    }

    get error(): any {
        return this._error;
    }

    get response(): any {
        return this._response;
    }

    public static isSuccess(res: any): boolean {
        return res && res.status && res.status == StatusDef.Success;
    }

    public static isSuccessPresent(res: any): boolean {
        return res && res.status && res.status == StatusDef.Success && res.data;
    }

    public isHttpStatusOk(): boolean {
        return this._status == HttpStatus.StatusOK
    }

    public isHttpStatus2xx(): boolean {
        return this._status > HttpStatus.StatusEarlyHints && this._status < HttpStatus.StatusMultipleChoices;
    }

    public isHttpStatusForbidden(): boolean {
        return this._status == HttpStatus.StatusForbidden
    }
}